import React from 'react';
import {Navigate} from 'react-router-dom';
import { useUserContext } from 'providers/user-context';
import {APP_PATHS, TOKEN_KEY} from '../../constants';
import {useLocalStorage} from 'hooks/useLocalStorage';

/**
 * ProtectedRoute component checks if the user is logged in and token is present in localStorage.
 * If the user is not logged in, it redirects them to the home page.
 * If the user is logged in, it renders the children components.
 */

const ProtectedRoute = ({children}: {children: React.ReactNode}) => {
  const { user } = useUserContext();
  const {value: token} = useLocalStorage(TOKEN_KEY);
    
  // If user not logged in redirect him to home page
  return !!token && !!user ? <>{children}</> : <Navigate to={APP_PATHS.BASE} replace />;
};

export default ProtectedRoute;
